import React, {useEffect, useMemo, useRef} from 'react';
import EpmsImage from "../../../../Common/EpmsImage";
import {formatCurrency, getBoxSize} from "../../../../../utils";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import useResizeObserver from "../../../hooks/useResizeObserver";
import PaperCopyPreview from "./PaperCopyPreview";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
  orderLineContainer: {
    backgroundColor: '#ECECEC',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1
  },
  orderLineTopRow: {
    display: 'flex',
    flexBasis: 'fit-content',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  orderLineBottomRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
  },
  orderLineImageContainer: {
    display: 'flex',
    flexGrow: 1,
    position: 'relative',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3)
  },
}));

export default ({orderLine, overrideProduct, overrideFilter, overrideWhiteBorder, overrideCropRect, overrideQuantity}) => {
  const classes = useStyles();
  const { getProductByUuid, isWhiteBorderProduct, calculateLinePrice } = usePriceList();
  const {t} = useTranslation();

  let filter = overrideFilter ? overrideFilter : orderLine.image.filter;

  const file = orderLine.files[0];
  let cropRect = orderLine.image.cropRect;

  const product = useMemo (() => {
    let product = getProductByUuid(orderLine.product.uuid);
    if (overrideProduct) {
      product = getProductByUuid(overrideProduct.uuid);
    }
    return product;
  }, [overrideProduct, orderLine]);

  if (typeof(overrideCropRect) != 'undefined') {
    cropRect = overrideCropRect;
  }

  console.log('Product is', product);

  const linePrice = useMemo(() => {
    console.log('Product', product, orderLine);
    let p= overrideProduct || product;
    let quantity = overrideQuantity || orderLine.quantity;
    return calculateLinePrice(p.uuid, quantity);

  }, [orderLine, overrideQuantity, overrideProduct, product])

  const whiteBorder = typeof(overrideWhiteBorder) != 'undefined'
    ? overrideWhiteBorder : isWhiteBorderProduct(product);

  console.log('White border', whiteBorder, orderLine);

  console.log('Preview, override product', overrideProduct, filter)


  return <div className={classes.orderLineContainer}>
    <div className={classes.orderLineTopRow}>
      <div className={classes.orderLineName}>
        {t('%d pcs', {
          postProcess: 'sprintf',
          sprintf: [overrideQuantity || orderLine.quantity]
        })} {product.name}
      </div>
      <div className={classes.orderLineQuantity}>{formatCurrency(linePrice)}</div>
    </div>
    <div className={classes.orderLineImageContainer}>
      <PaperCopyPreview product={product} file={file} filter={filter} cropRect={cropRect}
                        adaption={orderLine.image.adaption == 1 ? 'fit-in' : 'fill-in'} whiteBorder={whiteBorder}
      />
    </div>
  </div>
}